// Pílula "✨ Decorar" no canto inferior-direito de CADA foto da galeria. Clique NÃO
// abre o lightbox (stopPropagation) — só pede pro host abrir o decorador com a URL
// GRANDE daquela foto. Só é renderizada quando o decorador está ativo (as galerias
// decidem isso via useDecoradorAtivo); a visibilidade no hover (desktop) fica a cargo
// do CSS da própria galeria, via a classe global "decorar-pill".
import React from 'react';
import { abrirDecorador } from './decoradorBus';
import styles from './DecorarPhotoPill.module.css';

const DecorarPhotoPill: React.FC<{ fotoUrl?: string }> = ({ fotoUrl }) => {
    if (!fotoUrl) return null;

    const onClick = (event: React.MouseEvent) => {
        event.stopPropagation();
        event.preventDefault();
        abrirDecorador(fotoUrl);
    };

    return (
        <button
            type="button"
            className={`decorar-pill ${styles.pill}`}
            onClick={onClick}
            aria-label="Veja esta foto decorada com inteligência artificial"
            title="Veja esta foto decorada ✨"
        >
            <span aria-hidden="true">✨</span>
            <span className={`decorar-pill-label ${styles.label}`}>Decorar</span>
        </button>
    );
};

export default DecorarPhotoPill;
